import styled from "@emotion/styled";

import { TextHighlighter } from "lib/core_components/TextHighlighter";
import UIcon, { IconProps } from "../../lib/icons/untitled_ui/UIcon";
import { Flex, Text } from "../../styles/utility-components";
import { ATTRIBUTE_NAMES, SummaryType, SummaryValue } from "./utils";

const ICONS_BY_ATTRIBUTE: Record<SummaryType, IconProps["icon"]> = {
  thingBeingProcured: "package01",
  contractValue: "file06",
  topicRelevance: "copy02",
  mentionedParties: "briefcase02",
  bidRequirements: "clipboardCheck",
};

type Props = {
  summaryPoint: SummaryValue;
  wordsToHighlight: string[] | undefined;
};

export default function SummaryPoint({
  summaryPoint: { content, attributeName },
  wordsToHighlight,
}: Props) {
  if (!content) return null;

  return (
    <Flex column gap={8}>
      <Flex gap={8} alignItems="center">
        <IconBackground>
          <UIcon icon={ICONS_BY_ATTRIBUTE[attributeName]} size={14} color="yellow500" />
        </IconBackground>
        <Text bold description textTransform="uppercase">
          {ATTRIBUTE_NAMES[attributeName]}
        </Text>
      </Flex>
      <HighlighterWrapper>
        <TextHighlighter content={content} wordsToHighlight={wordsToHighlight} />
      </HighlighterWrapper>
    </Flex>
  );
}

const IconBackground = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.yellow50,
  borderRadius: 4,
  width: 26,
  height: 26,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const HighlighterWrapper = styled.div({
  whiteSpace: "pre-wrap",
});
